var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.74563C3 4.91067 3.5187 4.16357 4.30101 3.87176L11.301 1.26064C11.7518 1.09248 12.2482 1.09248 12.699 1.26064L19.699 3.87176C20.4813 4.16357 21 4.91067 21 5.74563V9.24994H22C22.4142 9.24994 22.75 9.58573 22.75 9.99994C22.75 10.4141 22.4142 10.7499 22 10.7499V21.2499C22.4142 21.2499 22.75 21.5857 22.75 21.9999C22.75 22.4141 22.4142 22.7499 22 22.7499H2C1.58579 22.7499 1.25 22.4141 1.25 21.9999C1.25 21.5857 1.58579 21.2499 2 21.2499V10.7499C1.58579 10.7499 1.25 10.4141 1.25 9.99994C1.25 9.58573 1.58579 9.24994 2 9.24994H3V5.74563ZM14 5.99991C14 4.89534 13.1046 3.99991 12 3.99991C10.8954 3.99991 10 4.89534 10 5.99991C10 7.10448 10.8954 7.99991 12 7.99991C13.1046 7.99991 14 7.10448 14 5.99991ZM9 21.2499H15V16.9999C15 16.4476 14.5523 15.9999 14 15.9999H10C9.44771 15.9999 9 16.4476 9 16.9999V21.2499ZM10 12.2499C9.58579 12.2499 9.25 12.5857 9.25 12.9999C9.25 13.4141 9.58579 13.7499 10 13.7499H14C14.4142 13.7499 14.75 13.4141 14.75 12.9999C14.75 12.5857 14.4142 12.2499 14 12.2499H10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseAlt4);
export default __webpack_public_path__ + "static/media/house-alt-4.f3830a21d4754abf5060f3e681e88c10.svg";
export { ForwardRef as ReactComponent };